(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-cart"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.qty-btn').forEach((button) => {
    button.addEventListener('click', () => {
      const input = document.getElementById(button.dataset.target);
      if (!input) return;
      const current = Number.parseInt(input.value || '0', 10);
      const step = Number.parseInt(button.dataset.step || '0', 10);
      input.value = Math.max(0, current + step);
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[id^="Product-"]').forEach((root) => {
    const variantSelect = root.querySelector('.product-variant-select');
    const optionSelects = Array.from(root.querySelectorAll('.product-option-select'));
    const price = root.querySelector('.product-price');
    const comparePrice = root.querySelector('.product-compare-price');
    const addButton = root.querySelector('.product-add-button');
    const mainImage = root.querySelector('.product-main-image');
    const thumbnails = Array.from(root.querySelectorAll('.product-thumbnail'));

    const setActiveThumbnail = (url) => {
      if (!url) return;
      thumbnails.forEach((thumb) => {
        thumb.classList.toggle('is-active', thumb.dataset.imageUrl === url);
      });
    };

    thumbnails.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        if (mainImage && thumb.dataset.imageUrl) {
          mainImage.src = thumb.dataset.imageUrl;
          setActiveThumbnail(thumb.dataset.imageUrl);
        }
      });
    });

    const updateVariant = () => {
      if (!variantSelect || optionSelects.length === 0) return;

      const selectedValues = optionSelects.map((select) => select.value);
      const match = Array.from(variantSelect.options).find((option) => {
        try {
          return JSON.stringify(JSON.parse(option.dataset.options)) === JSON.stringify(selectedValues);
        } catch (error) {
          return false;
        }
      });

      if (!match) return;

      variantSelect.value = match.value;

      if (price && match.dataset.price) {
        price.textContent = match.dataset.price;
      }

      if (comparePrice) {
        comparePrice.textContent = match.dataset.comparePrice || '';
        comparePrice.hidden = !match.dataset.comparePrice;
      }

      if (mainImage && match.dataset.image) {
        mainImage.src = match.dataset.image;
        setActiveThumbnail(match.dataset.image);
      }

      if (addButton) {
        const available = match.dataset.available === 'true';
        addButton.disabled = !available;
        addButton.textContent = available
          ? addButton.dataset.availableLabel || 'Ajouter au panier'
          : addButton.dataset.soldOutLabel || 'Épuisé';
      }

      const url = new URL(window.location.href);
      url.searchParams.set('variant', match.value);
      window.history.replaceState({}, '', url);
    };

    optionSelects.forEach((select) => select.addEventListener('change', updateVariant));
  });
});

  } catch(e) { console.error(e); }
})();
})();
